// KPI formula 구문 검증 (순수 — DB/shell 무관, 단위 테스트 용이)

import { parseFormula, collectVariableNames, collectFunctionNames } from './parser.js'
import { builtinFunctions } from './functions.js'

export interface FormulaSyntaxResult {
  /** 하드 에러: 구문 오류, 미지 함수. */
  errors: string[]
  /** 경고(저장 허용). 이 순수 단계에선 비어있고, metric 존재 검사 등 DB 단계에서 채워짐. */
  warnings: string[]
  /** 수식이 참조하는 변수(=metric 이름) 목록. */
  variables: string[]
}

/**
 * 수식의 구문·함수 유효성만 검사한다 (DB 접근 없음).
 *  - 파싱 실패 → 에러
 *  - 화이트리스트에 없는 함수 → 에러
 *  - 변수는 추출만 (존재 여부 판단은 호출측 DB 단계)
 */
export function validateFormulaSyntax(
  formula: string,
  knownFunctions: Set<string> = new Set(Object.keys(builtinFunctions))
): FormulaSyntaxResult {
  const errors: string[] = []
  const warnings: string[] = []

  let ast
  try {
    ast = parseFormula(formula)
  } catch (e) {
    errors.push(`구문 오류: ${(e as Error).message}`)
    return { errors, warnings, variables: [] }
  }

  for (const fn of collectFunctionNames(ast)) {
    if (!knownFunctions.has(fn)) errors.push(`알 수 없는 함수: '${fn}'`)
  }

  return { errors, warnings, variables: collectVariableNames(ast) }
}
